const CryptoJS = require("crypto-js");
import JSEncrypt from '@/global-config/request/rsa/jsencrypt'
import RsaKeys from '@/global-config/request/rsa/rsa-keys'

const encryptAES = (data) => {
    let randomKey = randomString()
    let msg = CryptoJS.enc.Utf8.parse(data);

    const Key = CryptoJS.enc.Utf8.parse(randomKey);
    const IV = CryptoJS.enc.Utf8.parse(randomKey.substring(0,16));




    var encryptedText = CryptoJS.AES.encrypt(msg, Key, {
        iv: IV,
        // keySize: 128,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });



    return {
        data : encryptedText,
        randomKey: randomKey,
    }


}

const decryptAES = (encryptedData,randomKey) => {

    var Key = CryptoJS.enc.Utf8.parse(randomKey);
    var IV = CryptoJS.enc.Utf8.parse(randomKey.substr(0,16));

    // var decryptedText = CryptoJS.AES.decrypt(encryptedData, Key, {                             // 4. Use decrypt instead of encrypt
    //     iv: IV,
    //     mode: CryptoJS.mode.CBC,
    //     padding: CryptoJS.pad.Pkcs7
    // });

    var decryptedText = CryptoJS.AES.decrypt(encryptedData, '683e3dbc6d044721e3353bb0c42e7a7dda0219a8c77659454543470500ab01d2', {                             // 4. Use decrypt instead of encrypt
        iv: '7de37afbfbb72086',
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });

    // return decryptedText.toString(CryptoJS.enc.Utf8);
    return decryptedText;
}

const encryptRSA = (ciphertext) => {
    var encrypt = new JSEncrypt();
    let key = RsaKeys.CLIENT_PUBLIC_KEY
    key = key.replace(/\\n/g, '\n')
    encrypt.setPublicKey(key);
    return encrypt.encrypt(ciphertext);
}

const encryptUriWithRSA = (ciphertext) => {
    var encrypt = new JSEncrypt();
    let key = RsaKeys.URI_CLIENT_PUBLIC_KEY
    key = key.replace(/\\n/g, '\n')
    encrypt.setPublicKey(key);
    return encrypt.encrypt(ciphertext);
}

const decryptRSA = (ciphertext) => {
    var decrypt = new JSEncrypt();
    decrypt.setPrivateKey(RsaKeys.SERVER_PRIVATE_KEY);
    return decrypt.decrypt(ciphertext).replace(/^"(.*)"$/, '$1');
}

const randomString = (length = 16, chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ') => {
    var result = '';
    for (var i = length; i > 0; --i) result += chars[Math.round(Math.random() * (chars.length - 1))];
    return result;
}

const encryptRequest = (data) =>{
    let aesEncryptedData = encryptAES(JSON.stringify(data))
    return {
        aesEncryptedData : aesEncryptedData.data.toString() ,
        rsaEncryptedKey :encryptRSA(aesEncryptedData.randomKey)
    }
}

const generateLongObfuscatedNumber = () => {
    const timestamp = Date.now(); // Current time in milliseconds
    const random = Math.floor(Math.random() * 1000000000); // Random 9-digit number

    // Combine timestamp and random number as a string
    const combined = `${timestamp}${random}`;

    // Convert to Base36 (letters + numbers) for obfuscation
    let obfuscated = '';
    for (let i = 0; i < combined.length; i += 6) {
        obfuscated += parseInt(combined.slice(i, i + 6), 10).toString(36);
    }

    return obfuscated;
}

const decryptResponse = (encryptedData,randomKey) => {
    let decryptRSAKey = decryptRSA(randomKey)
    return decryptAES(encryptedData,decryptRSAKey)
}

export default {
    encryptAES,
    decryptAES,
    encryptRSA,
    decryptRSA,
    encryptRequest,
    decryptResponse,
    encryptUriWithRSA,
    generateLongObfuscatedNumber
}